<!-- このcomponentはサインイン直後に表示されるダミーページです。
     role.guardでsmile9ロールを判定した後、すぐに別ページへ遷移します。-->
